$( document ).ready( function() {

    $( "#shopping_grid__load_more" ).click( function() {
        $(this).parent().find('#shopping_grid__items').css('max-height', 'none');
        $(this).fadeOut();
    });
});